// Copyright (c) 2016 Deere & Company

import React, {Component, PropTypes} from 'react';
import CheckboxWithSearchFilterControlled from '../../../shared/components/facets/checkbox-with-search-filter/controlled';
import FacetFooter from '../../../shared/components/facets/facet-footer';
import FacetsDateRangePickerControlled from '../../../shared/components/facets/date-range-picker/controlled';
import {addCollectionLabels} from '../../../shared/services/add-collection-labels';
import {create as createHashMap} from '../../../shared/services/hashmap';
import {isDealerFacetInvalid} from '../../../shared/services/facets';

class TransferApprovalFacets extends Component {

    state = {
        dateRequestPickerExpanded: false,
        dealerLocationExpanded: false
    };

    onAccordionToggle = accordionName => {

        this.setState({
            [accordionName]: !this.state[accordionName]
        });

    };

    anyFacetsOpen = () =>
        this.state.dateRequestPickerExpanded || this.state.dealerLocationExpanded;

    render() {

        return (
            <div className='transfer-approval-facets'>
                <CheckboxWithSearchFilterControlled
                    initialState={createHashMap(this.props.dealerAccountsFacet.selectedDealers, 'account')}
                    isExpanded={this.state.dealerLocationExpanded}
                    list={addCollectionLabels(this.props.dealerAccountsFacet.displayedDealers)}
                    minNumberOfItems={4}
                    onCheckboxListChange={this.props.onCheckboxListChange}
                    onClick={this.onAccordionToggle.bind(this, 'dealerLocationExpanded')}
                    onInputChange={this.props.onInputChange}
                    onToggleAll={this.props.onToggleAll}
                    searchInput={this.props.dealerAccountsFacet.searchInput}
                    searchPlaceholder='DEALER_LOCATION_FILTER'
                    title='DEALER_LOCATIONS'
                    valueKey='account'
                />
                <FacetsDateRangePickerControlled
                    dateFormat={this.props.dateFormat}
                    dateRange={this.props.requestedDateRange.dateRange}
                    isExpanded={this.state.dateRequestPickerExpanded}
                    maxDate={this.props.requestedDateRange.maxDate}
                    minDate={this.props.requestedDateRange.minDate}
                    onChange={this.props.onDatePickerChange}
                    onClick={this.onAccordionToggle.bind(this, 'dateRequestPickerExpanded')}
                    title='REQUESTED_DATES'
                />
                {this.anyFacetsOpen() ?
                    <FacetFooter
                        disabled={isDealerFacetInvalid(this.props.dealerAccountsFacet)}
                        onApply={this.props.onApply}
                        onReset={this.props.onReset}
                    /> : null}
            </div>
        );

    }

}

TransferApprovalFacets.displayName = 'TransferApprovalFacets';
TransferApprovalFacets.propTypes = {
    dateFormat: PropTypes.string.isRequired,
    dealerAccountsFacet: PropTypes.object.isRequired,
    onApply: PropTypes.func.isRequired,
    onCheckboxListChange: PropTypes.func.isRequired,
    onDatePickerChange: PropTypes.func.isRequired,
    onInputChange: PropTypes.func.isRequired,
    onReset: PropTypes.func.isRequired,
    onToggleAll: PropTypes.func.isRequired,
    requestedDateRange: PropTypes.object.isRequired
};

export default TransferApprovalFacets;



// WEBPACK FOOTER //
// ./src/product/transfers/components/tranfer-approval-facets.js